<div class="mt-3">
  <form-workflow
    [form]="form"
    [sectionNumber]="6"
    [disabled]="closeDisabled"
    [service]="service"
  >
  </form-workflow>
</div>
